import * as React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import { useFormik } from "formik";
import { UseHrApp } from "../../utils/context";
import PositionedSnackbar from "../snackbar";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import axios from "axios";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "white",
  p: 4,
};

export default function AdminEditModal() {
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const id = searchParams.get("id");
  const {
    Emtoken,
    setshow,
    settext,
    setseverity,
    show,
    text,
    severity,
    SingleEmployee,
    token,
    departments,
    getSingleEmployee
  } = UseHrApp();

  useEffect(()=>{
getSingleEmployee(id)
  },[])

  const formic = useFormik({
    initialValues: {
      email: SingleEmployee.email,
      firstname: SingleEmployee.firstname,
      lastname: SingleEmployee.lastname,
      role: SingleEmployee.role, // Assuming the "role" field in the form should have a default value like "PornStart" for this example.
      salary: SingleEmployee.salary,
      contact: SingleEmployee.contact,
      departmentId: SingleEmployee.departmentId,
    },
    validate: (values) => {
      const errors = {};

      if (!values.email.trim()) {
        errors.email = "Required";
      } else if (
        !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(values.email)
      ) {
        errors.email = "Invalid Email address";
      }

      if (!values.firstname) {
        errors.firstname = "Required";
      }
      if (!values.lastname) {
        errors.lastname = "Required";
      }
      if (!values.contact) {
        errors.contact = "Required";
      }
      if (!values.gender) {
        errors.gender = "Required";
      }
      if (isNaN(values.salary)) {
        errors.salary = "Salary must be a number";
      } else if (values.salary < 0) {
        // You can also add additional checks if salary has specific constraints, like being non-negative.
        errors.salary = "Salary cannot be negative";
      }
      if (!values.departmentId) {
        errors.departmentId = "Required";
      }
      return errors;
    },
    onSubmit: (values) => {
      formic.resetForm();

      handleClose();
    },
  });

  

  async function EditInfo() {
    try {
      const res = await axios({
        url: "https://hr-app-api.onrender.com/employees/admin/edit",
        method: "PATCH",
        data: {
          id: SingleEmployee.id,
          email: formic.values.email,
          firstname: formic.values.firstname,
          lastname: formic.values.lastname,
          salary: formic.values.salary,
          role: formic.values.role,
          contact: formic.values.contact,
          departmentId: formic.values.departmentId
        },
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (res?.data?.status) {
        settext("Information Updated");
        setshow(true);
        setseverity("success");
        handleClose();
      }
    } catch (error) {
      settext("Leave not submitted");
      setshow(true);
      setseverity("error");
    }
  }

  useEffect(()=>{

  },[])

  return (
    <div>
      <button
        className="p-3 px-4 mt-[1em] text-white bg-[#b06bde]"
        onClick={handleOpen}
      >
        Edit
      </button>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Typography id="modal-modal-title" variant="h6" component="h2">
            Edit Employee Details
          </Typography>
          <div>
            <form
              className=" flex flex-col h-full gap-3"
              onSubmit={formic.handleSubmit}
            >
              <section className=" w-full flex justify-between gap-[1em]">
                <div className="flex flex-col gap-3 lg:gap-2">
                  <label htmlFor={"firstname"} className=" text-base">
                    Firstname
                  </label>
                  <input
                    name={"firstname"}
                    placeholder={"Enter firstname"}
                    value={formic.values.firstname}
                    onChange={formic.handleChange}
                    type={"text"}
                    className="outline-none border-[#000]/25 border-[1px] px-3 py-1 rounded focus:border-[#AFDBF5] w-full     text-black"
                  />
                  {formic.errors.firstname && (
                    <p className="text-[#EF0107] font-[300] text-[0.8rem]">
                      *{formic.errors.firstname}
                    </p>
                  )}
                </div>

                <div className="flex flex-col gap-3 lg:gap-2">
                  <label htmlFor={"lastname"} className=" text-base">
                    Lastname
                  </label>
                  <input
                    name={"lastname"}
                    placeholder={"Enter lastname"}
                    value={formic.values.lastname}
                    onChange={formic.handleChange}
                    type={"text"}
                    className="outline-none border-[#000]/25 border-[1px] px-3 py-1 rounded focus:border-[#AFDBF5] w-full    text-black"
                  />
                  {formic.errors.lastname && (
                    <p className="text-[#EF0107] font-[300] text-[0.8rem]">
                      *{formic.errors.lastname}
                    </p>
                  )}
                </div>
              </section>
              <div className=" w-[100%] flex justify-between gap-3">
                <div className="flex flex-col gap-3 lg:gap-2">
                  <label htmlFor={"email"} className=" text-base">
                    Email
                  </label>
                  <input
                    name={"email"}
                    placeholder={"Enter your email."}
                    value={formic.values.email}
                    onChange={formic.handleChange}
                    type={"text"}
                    className="outline-none border-[#000]/25 border-[1px] px-3 py-1 rounded focus:border-[#AFDBF5] w-full     text-black"
                  />
                  {formic.errors.email && (
                    <p className="text-[#EF0107] font-[300] text-[0.8rem]">
                      *{formic.errors.email}
                    </p>
                  )}
                </div>

                <div className="flex flex-col gap-3 lg:gap-2">
                  <label htmlFor={"contact"} className=" text-base">
                    Contact
                  </label>
                  <input
                    // This should be "contact" instead of "phone"
                    placeholder={"Enter contact info."}
                    value={formic.values.contact}
                    onChange={formic.handleChange}
                    type={"text"}
                    name="contact"
                    id="contact"
                    className="outline-none border-[#000]/25 border-[1px] px-3 py-1 rounded focus:border-[#AFDBF5] w-[120px] text-black"
                  />
                  {formic.errors.contact && (
                    <p className="text-[#EF0107] font-[300] text-[0.8rem]">
                      *{formic.errors.contact}
                    </p>
                  )}
                </div>
              </div>

              <section className=" w-full flex justify-between gap-[2em]">
                <div className="flex flex-col gap-3 lg:gap-2">
                  <label htmlFor={"salary"} className=" text-base">
                    Salary
                  </label>
                  <input
                    name={"salary"}
                    placeholder={"Enter Salary."}
                    value={formic.values.salary}
                    onChange={formic.handleChange}
                    type={"number"}
                    className="outline-none border-[#000]/25 border-[1px] px-3 py-1 rounded focus:border-[#AFDBF5] w-[150px]    text-black"
                  />
                  {formic.errors.salary && (
                    <p className="text-[#EF0107] font-[300] text-[0.8rem]">
                      *{formic.errors.salary}
                    </p>
                  )}
                </div>
                <div className="flex flex-col gap-3 lg:gap-2">
                  <label htmlFor={"Role"} className=" text-base">
                    Role
                  </label>
                  <input
                    name={"role"}
                    placeholder={"Enter Role"}
                    value={formic.values.role}
                    onChange={formic.handleChange}
                    type="text"
                    className="outline-none border-[#000]/25 border-[1px] px-3 py-1 rounded focus:border-[#AFDBF5] w-full    text-black"
                  />
                  {formic.errors.role && (
                    <p className="text-[#EF0107] font-[300] text-[0.8rem]">
                      *{formic.errors.role}
                    </p>
                  )}
                </div>
              </section>

              <div className=" w-[100%] flex justify-between gap-3">
                <div className="flex flex-col w-full gap-3 lg:gap-2">
                  <label htmlFor="departmentId">Department</label>
                  <select
                    id="departmentId"
                    name="departmentId"
                    className=" min-w-[80px] outline-none border-[#000]/25 border-[1px] px-3 py-2 rounded focus:border-[#AFDBF5]     text-black"
                    value={formic.values.departmentId}
                    onChange={formic.handleChange}
                  >
                    <option value="None">None</option>
                    {departments.map((item, index) => {
                      return <option value={item.id}>{item.name}</option>;
                    })}
                  </select>
                  {formic.errors.departmentId && (
                    <p className="text-[#EF0107] font-[300] text-[0.8rem]">
                      *{formic.errors.departmentId}
                    </p>
                  )}
                </div>
              </div>
            </form>
            <button
              className="w-full mt-[1em] h-full p-2 fond-[Archivo] font-semibold bg-[#9A6AFF]"
              onClick={EditInfo}
            >
              Edit
            </button>
          </div>
        </Box>
      </Modal>

      <PositionedSnackbar
        value={show}
        setshow={setshow}
        text={text}
        severity={severity}
      />
    </div>
  );
}

/**
 *              



                                <div className="flex flex-col gap-3 lg:gap-2">
                  <label htmlFor={"gender"} className="text-base">
                    Gender
                  </label>
                  <select
                    id="gender"
                    name="gender"
                    value={formic.values.gender}
                    onChange={formic.handleChange}
                    className="outline-none border-[#000]/25 border-[1px] px-3 py-1 rounded focus:border-[#AFDBF5] w-[150px] text-black"
                  >
                    <option value="">Select Gender</option>
                    <option value="male">Male</option>
                    <option value="female">Female</option>
                  </select>
                  {formic.errors.gender && (
                    <p className="text-[#EF0107] font-[300] text-[0.8rem]">
                      *{formic.errors.gender}
                    </p>
                  )}
                </div>


                

 */
